import { type PropsWithChildren } from "react";

import { Footer } from "@vega-core/components/Layout/Footer/Footer";
import { type FAQItemType } from "@vega-core/models/faq.type";

import { AuthHeader } from "../../components/AuthHeader";

import { Banner } from "./Banner";

type Props = PropsWithChildren<{
  faqItems?: FAQItemType[];
  title?: string;
}>;

export const RegistrationLayout = ({ children, faqItems, title }: Props) => (
  <div className="min-h-dvh p-4 lg:p-13 flex gap-13 bg-background/primary">
    <div className="w-full lg:w-1/2 flex flex-col bg-background/primary">
      <AuthHeader faqItems={faqItems} title={title} />
      <div className="flex flex-grow w-full flex-col justify-center p-1 align-center items-center">
        <div className="max-w-xl">{children}</div>
      </div>
      <Footer containerStyle="p-0" isLoggedIn={false} />
    </div>

    <div className="hidden lg:flex flex-1 justify-center items-center bg-background/auth/secondary rounded">
      <Banner />
    </div>
  </div>
);
